var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('div',{staticClass:"icon",class:_vm.colorClass},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icon}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }